import React from 'react';
import { editSpecialty } from '../../store/actions/UserAction';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import SpecialtyFormContainer from './SpecialtyFormContainer';
import { connect } from 'react-redux';
import { filterSubSpecialties } from '../../utils/SubSpecialties';
import { Formik } from 'formik';
import './addSpecialties.scss';

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;

function EditSpecialty(props) {
  const {
    uid,
    evento,
    item,
    flagEdit,
    specialties,
    editSpecialty,
    setFlagEdit,
    handleTrophieModalOpen,
    handleSnack,
    showLoading,
    hideLoading,
    helper,
    helperTrue,
    helperFalse,
    getValues,
    trophie,
    specialtyToEdit,
    subSpecialities,
    extraSubSpecialities
  } = props;

  function uniq(a) {
    let prims = {"boolean":{}, "number":{}, "string":{}}, objs = [];
    return a.filter(function(item) {
      let type = typeof item;
      if(type in prims)
        return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
      else
        return objs.indexOf(item) >= 0 ? false : objs.push(item);
    });
  }

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    let specialtiesData = []
    let subSpecialtiesData = []
    let data = {
      spe: [],
      sub: [],
      extra: [],
    }
    values.specialties.forEach(elem => {
      specialtiesData.push(elem.specialty)
      if (elem.subSpecialties.length && elem.subSpecialties.length !== 0) {
        elem.subSpecialties.forEach((subElem, index) => {
          const subElemKey = Object.keys(subElem)
          if (subElem[`${subElemKey[0]}`]) {
            subSpecialtiesData.push(...subElemKey)
          }
        })
      }
    })

    // Junta tu data actual con la de Redux
    data['spe'] = [
      ...specialtiesData,
      ...specialties,
    ]
    const newSpecialtiesData = uniq(data.spe)
    data['spe'] = newSpecialtiesData

    if (subSpecialities && subSpecialities.length && subSpecialities.length !== 0) {
      data['sub'] = [
        ...subSpecialtiesData,
        ...subSpecialities
      ]
    } else {
      data['sub'] = [
        ...subSpecialtiesData,
      ]
    }
    const newSubSpecialitiesData = uniq(data.sub)
    data['sub'] = newSubSpecialitiesData

    // Valida si el estado inicial cambió
    const specialtyChanged = values.specialties.some(elem => {
      if (elem.specialty !== specialtyToEdit) {
        return true
      } else {
        return false
      }
    })

    let filteredSpecialtyData
    let filteredSubSpecialityData
    if (specialtyChanged) {
      // Borra la especialidad con las subespecialidades que eliminaste
      filteredSpecialtyData = newSpecialtiesData.filter(elem => {
        return elem !== specialtyToEdit
      })
      data['spe'] = filteredSpecialtyData
      filteredSubSpecialityData = newSubSpecialitiesData.filter(el => {
        const oldSubs = filterSubSpecialties(specialtyToEdit)
        return !oldSubs.includes(el)
      });
      data['sub'] = filteredSubSpecialityData
    } else {
      // Borra las subespecialidades que quitaste
      filteredSubSpecialityData = newSubSpecialitiesData.filter(el => {
        const oldSubs = filterSubSpecialties(specialtyToEdit)
        let willDeleted
        if (oldSubs && oldSubs.length !== 0) {
          willDeleted = oldSubs.filter(subEl => {
            return !subSpecialtiesData.includes(subEl)
          })
          return !willDeleted.includes(el)
        } else {
          return el
        }
      });
      data['sub'] = filteredSubSpecialityData
    }
    
    // Valida que no haya un specialty en donde insertar estas extrasubspecialties
    let filteredExtraSubSpecialtyData = extraSubSpecialities && extraSubSpecialities.length ? extraSubSpecialities : []
    let index = -1
    if (extraSubSpecialities && extraSubSpecialities.length) {
      index = extraSubSpecialities.findIndex((elem) => {
        const specialty = Object.keys(elem)
        return specialty[0] === values.specialties[0].specialty
      })
    }
    if (index < 0) {
      let obj = {}
      obj[`${values.specialties[0].specialty}`] = values.specialties[0].extraSubSpecialties
      filteredExtraSubSpecialtyData.push(obj)
    } else {
      filteredExtraSubSpecialtyData[index][`${values.specialties[0].specialty}`] = values.specialties[0].extraSubSpecialties
    }
    data['extra'] = filteredExtraSubSpecialtyData

    let boolValues = false
    if (data.spe && data.spe.length && data.spe.length !== 0) {
      boolValues = true
    }

    setSubmitting(false);

    showLoading();
    editSpecialty(
      uid,
      data,
      boolValues,
    ).then(res => {
      hideLoading();
      if (boolValues === true && !trophie) {
        handleTrophieModalOpen(true)
      }
      setTimeout(() => {
        setFlagEdit(0);
        scroller.scrollTo('myScroll_Specialty', { smooth: true, offset: -64 });
        if (boolValues === false || trophie) {
          handleSnack();
        }
      }, 2000);
    }); 
  };

  const formValues = {
    flagEdit: 1,
    item: uid,
    specialties: [
      {
        specialty: specialtyToEdit,
        subSpecialties: [],
        extraSubSpecialties: []
      }
    ],
  };
  
  const resetTab = () => {
    scroller.scrollTo('myScroll_Specialty', { smooth: true, offset: -64 });
    evento(false);
  };

  return (
    <>
      <div className="addSpecialties">
        <Formik
          initialValues={formValues}
          onSubmit={handleSubmit}
          render={props => {
            return (
              <SpecialtyFormContainer
                {...props}
                evento={resetTab}
                nElem={item}
                helper={helper}
                helperTrue={helperTrue}
                helperFalse={helperFalse}
                getValues={getValues}
                edit={flagEdit}
              />
            )
          }}
        />
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  specialties: state.authClient.specialties,
  trophie: state.authClient.awardPerfil.specialties,
  subSpecialities: state.authClient.subSpecialities,
  extraSubSpecialities: state.authClient.extraSubSpecialities,
});

const mapDispatchToProps = dispatch => ({
  editSpecialty: (uid, data, boolValues) =>
    dispatch(editSpecialty(uid, data, boolValues)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSpecialty);
